<div class="sc-button-wrapper">
    <ng-container [ngSwitch]="primaryStyle">
        <div *ngSwitchDefault id="{{fieldName+'divSCButtonContainer'+key}}" class="gblButtonDiv">
            <span class="checkbox-spacer"></span>
            <div [ngClass]="fieldName">
                <button 
                    type="button" 
                    [disabled]="disabled" 
                    [attr.readonly]="disabled" 
                    class="btn btn-raised" 
                    [ngClass]="getButtonClasses()"
                    [style.justify-self]="buttonJustification"
                    [style.justify-content]="textJustification"
                    (click)="onFieldChange()">
                    {{btnLabel}}
                </button>
            </div>
        </div>

        <button 
            type="button" 
            *ngSwitchCase="'mat-button'" 
            mat-button 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-raised-button'" 
            mat-raised-button 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"          
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-stroked-button'" 
            mat-stroked-button 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"             
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-flat-button'" 
            mat-flat-button 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"          
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-icon-button'" 
            mat-icon-button 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"             
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-fab'" 
            mat-fab 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"             
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>

        <button 
            type="button" 
            *ngSwitchCase="'mat-mini-fab'" 
            mat-mini-fab 
            [id]="fieldName" 
            [disabled]="disabled" 
            [attr.readonly]="disabled" 
            class="btn btn-raised" 
            [ngClass]="getButtonClasses()"
            [style.justify-self]="buttonJustification"
            [style.justify-content]="textJustification"             
            (click)="onFieldChange()" 
            [color]="color">
            {{btnLabel}}
            <mat-icon *ngIf="icon">{{icon}}</mat-icon>
        </button>
    </ng-container>
</div>
